class Language {
    constructor({ id, name, code, iso_code, key, locale } = {}) {
        this.id = id; // public property
        this.name = name; // public property
        this.code = code || iso_code || key || locale || ''; // public property
        this.iso_code = iso_code || this.code;
    }

    // Optional method for additional logic if needed
    getDisplayName() {
        return `${this.name} (${this.code})`;
    }
}

export default Language;
